export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'Cadastros',
    icon: 'PlusSquareIcon',
    accessLevel: [6], // Apenas Administradores
    children: [
      {
        title: 'Abas',
        route: 'list-tabs',
      },
      // {
      //   title: 'Atenção Continuada',
      //   route: 'list-atencao_continuadas',
      // },
      // {
      //   title: 'Empresas',
      //   route: 'list-empresas',
      // },
      {
        title: 'Fabricantes',
        route: 'list-fabricantes',
      },
      {
        title: 'Famílias',
        route: 'list-familias',
      },
      // {
      //   title: 'Finalização Receita',
      //   route: 'list-finalizacao_receitas',
      // },
      {
        title: 'Fornecedores',
        route: 'list-fornecedores',
      },
      {
        title: 'Grupos',
        route: 'list-grupos',
      },
      {
        title: 'Materiais',
        route: 'list-materiais',
      },
      // {
      //   title: 'Pacientes',
      //   route: 'list-pacientes',
      // },
      {
        title: 'Profissionais',
        route: 'list-profissionais',
      },
      // {
      //   title: 'Receitas',
      //   route: 'list-receitas',
      // },
      {
        title: 'Rotas',
        route: 'list-rotas',
      },
      {
        title: 'Subgrupos',
        route: 'list-sub_grupos',
      },
      // {
      //   title: 'Tipos de Conselhos',
      //   route: 'list-tipo_conselhos',
      // },
      {
        title: 'Tipos de Movimentação',
        route: 'list-tipo_movimentacoes',
      },
      {
        title: 'Tipos de Profissionais',
        route: 'list-tipo_profissionais',
      },
      {
        title: 'Tipos de Receita',
        route: 'list-tipo_receitas',
      },
      {
        title: 'Tipos de Veículo',
        route: 'list-tipo_veiculos',
      },
      {
        title: 'Unidades Materiais',
        route: 'list-unidade_materiais',
      },
      {
        title: 'Unidades',
        route: 'list-unidades',
      },
      {
        title: 'Usuários',
        route: 'list-users',
      },
      {
        title: 'Veículos',
        route: 'list-veiculos',
      },
    ],
  },
  {
    title: 'Pesquisa por Material',
    route: 'list-pesquisa-material',
    icon: 'SearchIcon',
  },
  {
    title: 'Pesquisa por Unidade',
    route: 'list-pesquisa-unidade',
    icon: 'SearchIcon',
  },
  // {
  //   title: 'Semanal',
  //   icon: 'CalendarIcon',
  //   route: 'pedido-semanal'
  // },
  {
    title: 'Movimentar',
    icon: 'MoveIcon',
    route: 'list-movimentos',
    accessLevel: [6, 2] // Apenas Administrador e Farmacêutico
  },
  {
    title: 'Estoque',
    icon: 'BoxIcon',
    route: 'list-estoques',
    accessLevel: [6, 2, 3, 4] // Admin, Farmacêutico, Auxiliar, Supervisor
  },
  {
    title: 'Pedidos',
    icon: 'GridIcon',
    route: 'list-pedidos',
    accessLevel: [6, 2, 3, 4] // Admin, Farmacêutico, Auxiliar, Supervisor
  },
  {
    title: 'Pedidos Baixa Estoque',
    icon: 'CheckSquareIcon',
    route: 'list-pedidos-baixa-estoque',
    accessLevel: [6, 2, 3] // Admin, Farmacêutico, Auxiliar de Farmácia (NÃO Supervisor de Enfermagem)
  },
  {
    title: 'Gestão de Documentos',
    icon: 'FileIcon',
    route: 'list-assuntos',
  },
]